<template>
  <div class="content">
    <div class="header">
      <div
        :class="is_status == 1 ? 'btn btnCurrent' : 'btn'"
        @click="is_status = 1"
      >
        自动标签
      </div>
      <div
        :class="is_status == 2 ? 'btn btnCurrent' : 'btn'"
        @click="is_status = 2"
      >
        手动标签
      </div>
    </div>
    <div class="bottom">
      <div class="box" v-if="is_status == 1">
        <div class="option">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addSlice(1)"
            plain
            >添加自动标签</el-button
          >
          <div class="search">
            <el-input size="small" placeholder="请输入标签名称"></el-input>
            <el-button size="small">搜索</el-button>
          </div>
        </div>
        <div class="cards">
          <div style="margin-left: 20px;">
            <strong>商家自定义标签</strong>
            <span>注：每天5:00系统更新数据</span>
          </div>
          <div class="ul">
            <div class="li" v-for="(item, index) in tableList" :key="index">
              <div class="liTop">
                <h3 class="ng-binding">{{ item.title }}</h3>
                <p class="ng-binding">符合条件用户数：{{ item.user_num }}人</p>
                <p class="ng-binding">数据更新时间：{{ item.change_time? mydateFormat(item.change_time):"--" }}</p>
                <p class="ng-binding">标签创建时间：{{ item.create_time }}</p>
              </div>
              <div class="liBottom">
                <div>
                  <el-button type="text" @click="manualUpdateTag(item.id)">手动更新</el-button>
                </div>
                <div>
                  <el-button type="text" @click="go(1, item.id)">标签详情</el-button>
                </div>
                <div>
                  <el-button type="text" @click="del(1, item.id)">删除</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" v-else>
        <div class="option">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addSlice(2)"
            plain
            >添加手动标签</el-button
          >
          <div class="search">
            <el-input size="small" placeholder="请输入标签名称"></el-input>
            <el-button size="small">搜索</el-button>
          </div>
        </div>
        <div class="cards">
          <div style="margin-left: 20px;">
            <strong>手动标签</strong>
            <span>注：永久性手动标签</span>
          </div>
          <div class="ul">
            <div class="li" v-for="(item, index) in CommonList" :key="index">
              <div class="liTop">
                <h3 class="ng-binding">{{ item.title }}</h3>
                <p class="ng-binding">
                  符合条件用户数：{{ item.user_num }}人
                </p>
                <p class="ng-binding" v-if="false">数据更新时间：{{ item.change_time? mydateFormat(item.change_time):"--" }}</p>
                <p class="ng-binding">标签创建时间：{{ item.create_time }}</p>
              </div>
              <div class="liBottom">
                <div>
                  <el-button type="text" @click="addSlice(2, item.id)">编辑</el-button>
                </div>
                <div>
                  <el-button type="text" @click="go(2, item.id)">标签详情</el-button>
                </div>
                <div>
                  <el-button type="text" @click="del(2, item.id)">删除</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { listTag, delTag, listCommonTag, updateTag } from "@/api/market";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      is_status: 1,
      page: 0,
      total: 0,
      tableList: [],
      CommonList: []
    };
  },
  mounted() {
    if (this.$route.query.jude) {
      this.is_status = this.$route.query.jude;
    }
    this.getList();
  },
  methods: {
    addSlice(index, edit = 0) {
      this.$router.push({
        path: `adSign?jude=${index}`
      });
      if (edit != 0) {
        localStorage.setItem("editCommon", edit);
      }
    },
    // 分頁
    handleCurrentChange(val) {
      console.log("val", val);
    },
    getList() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      listTag(data).then(res => {
        if (res.code == 200) {
          this.tableList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("标签列表", res);
      });
      listCommonTag(data).then(res => {
        if (res.code == 200) {
          this.CommonList = res.data;
        } else {
          this.$message.waring(res.msg);
        }
        console.log("手动标签列表", res);
      });
    },
    del(judes, id) {
      console.log("删除", id);
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() =>{
        let data = {
          token: this.token,
          app_id: this.app_id,
          id: id
        };
        delTag(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.reload();
            this.is_status = judes;
          } else {
            this.$message.waring(res.msg);
          }
        });
      })
    },
    go(jude, id) {
      this.$router.push({
        path: `SignDetails?id=${id}`
      });
      localStorage.setItem("signDetailsJude", jude);
    },
    // updateTag
    manualUpdateTag(id) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      updateTag(data).then(res => {
        this.$message(res.msg);
        if(res.code == 200){
          this.getList();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;

  background: #fff;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 56px;
    font-size: 14px;
    color: #595961;
    line-height: 34px;
    padding: 11px 0;
    display: flex;
    .btn {
      width: 100px;
      height: 36px;
      text-align: center;
      border-radius: 6px;
      margin-right: 5px;
      cursor: pointer;
    }
    .btnCurrent {
      color: #fff;
      background: #2589ff;
    }
  }
  .bottom {
    flex: 1;

    overflow-y: auto;

    .box {
      width: 100%;
      background: #f2f2f6;
      border-radius: 6px;
      padding: 10px;
    }
    .option {
      width: 100%;
      padding: 10px 20px;
      background-color: #fff !important;
      color: #595961;
      height: 50px;
      margin-bottom: 10px;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      .search {
        width: 345px;
        display: flex;
      }
    }
    .cards {
      padding-top: 15px;
      padding-bottom: 15px;
      background-color: #fff;
      border-radius: 6px;
      margin-bottom: 10px;
      .ul {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;

        .li {
          width: 310px;
          height: 180px;
          border: 1px solid #dddce2;
          border-radius: 10px;
          margin-left: 30px;
          margin-top: 20px;
          .liTop {
            height: 138px;
            padding: 20px 20px 10px;
            > h3 {
              margin-bottom: 10px;
              font-size: 16px;
            }
            > p {
              margin-bottom: 10px;
            }
          }
          .liBottom {
            display: flex;
            border-top: #dddce2 1px solid;
            text-align: center;
            line-height: 40px;
            color: #2589ff;
            height: 40px;
            margin: 0;
            > div {
              width: 33%;
              cursor: pointer;
            }
            div:nth-child(2) {
              border-left: 1px solid #dddce2;
              border-right: 1px solid #dddce2;
            }
          }
        }
      }
    }
  }
}
</style>
